import React, { useContext, useState } from "react";
import Card from "canvas-core-react/lib/Card";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import { CoachContext } from "../../context";
import Link from "canvas-core-react/lib/Link";
import Margin from "canvas-core-react/lib/Margin";
import LineSeparator from "canvas-core-react/lib/LineSeparator";
import { ButtonCancel } from "../buttonCancel";
import { ButtonOk } from "../buttonOk";
import { ModalExpense } from "../modalExpense";
import IconMortgageIllustrative from "canvas-core-react/lib/IconMortgageIllustrative";
import IconInsuranceIllustrative from "canvas-core-react/lib/IconInsuranceIllustrative";
import IconTipsIllustrative from "canvas-core-react/lib/IconTipsIllustrative";
import IconOnlineIllustrative from "canvas-core-react/lib/IconOnlineIllustrative";
import IconGroceryIllustrative from "canvas-core-react/lib/IconGroceryIllustrative";
import IconAutoIllustrative from "canvas-core-react/lib/IconAutoIllustrative";
import IconDepositIllustrative from "canvas-core-react/lib/IconDepositIllustrative";
import IconPaperlessIllustrative from "canvas-core-react/lib/IconPaperlessIllustrative";


import { formatThousandsSeparator, tagCoach } from "../../utils/utils";

interface ExpenseProps {
  title: string;
  contenido: string;
  step?: number;
  onClickParent?: any;
  index?: number;
  tag: any;
}

export const Expense = ({
  title,
  contenido,
  step = 0,
  onClickParent,
  index = 0,
  tag = 0,
}: ExpenseProps) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editField, setEditField] = useState("");
  const [editAmount, setEditAmount] = useState("");
  const { values } = useContext(CoachContext);

  const resetModal = () => {
    setModalIsOpen(false);
    setIsEdit(false);
  };

  const chooseIcon = (iconName: string) => {
    switch (iconName) {
      case "renta-hipoteca":
        return <IconMortgageIllustrative />;
      case "agua":
        return <IconInsuranceIllustrative />;
      case "luz":
        return <IconTipsIllustrative />;
      case "gas":
        return <IconPaperlessIllustrative />;
      case "internet":
        return <IconOnlineIllustrative />;
      case "alimentos":
        return <IconGroceryIllustrative />;
      case "gasolina-transporte":
        return <IconAutoIllustrative />;
      default:
        return <IconDepositIllustrative />;
    }
  };
  const onTrigger = (event: any) => {
    onClickParent(event);

    if (tag !== undefined)
      tagCoach(tag.step, "", tag.dimension3, "1");
  }
  return (
    <>
      <Card>
        <Margin xs={42} sm={42} md={42} lg={42} side="bottom">
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextSubtitle component="span">
                Estos son tus gastos ingresados:
              </TextSubtitle>
            </Column>
          </Row>
          <Row>
            <Column xs={4} sm={8} md={12} lg={12}>
              <TextBody component="span">
                Puedes editar o agregar un gasto
              </TextBody>
            </Column>
          </Row>
        </Margin>
        <Row>
          <Column xs={4} sm={8} md={12} lg={12}>
            <TextSubtitle component="span">{title}</TextSubtitle>
          </Column>
        </Row>
        <Row>
          <Column xs={4} sm={8} md={12} lg={12}>
            <TextBody component="span">{contenido}</TextBody>
          </Column>
        </Row>
        <Margin xs={18} sm={18} md={18} lg={18}>
          {values &&
            values.map((value: any) => {
              if (
                (value && value.subGroup === "indispensables") ||
                (value && value.subGroup === "extra")
              ) {
                return (
                  <>
                    <Row>
                      <Column xs={4} sm={8} md={1} lg={1}>
                        {chooseIcon(value.name)}
                      </Column>
                      <Column xs={2} sm={4} md={6} lg={6}>
                        <TextSubtitle component="span">
                          {value.title ? value.title : ""}
                        </TextSubtitle>
                      </Column>
                      <Column xs={2} sm={4} md={2} lg={2}>
                        <TextSubtitle component="span">
                          {value.value ? formatThousandsSeparator(parseInt(value.value)) : "kek"}
                        </TextSubtitle>
                      </Column>
                      <Column xs={2} sm={4} md={2} lg={2}>
                        <div
                          onClick={() => {
                            setEditField(value.title);
                            setEditAmount(value.value);
                            setIsEdit(true);
                            setModalIsOpen(true);
                          }}
                        >
                          <TextBody component="p">
                            <Link href="javascript:void(0);" type="emphasis">
                              Editar
                            </Link>
                          </TextBody>
                        </div>
                      </Column>
                    </Row>
                    <Row>
                      <Column xs={4} lg={12}>
                        <LineSeparator />
                      </Column>
                    </Row>
                  </>
                );
              }
            })}
        </Margin>
        <Margin xs={48} sm={48} md={48} lg={48}>
          <Row>
            <Column xs={4} sm={8} md={6} lg={6}>
              <ButtonCancel
                title="Agregar gasto"
                onClick={() => setModalIsOpen(true)}
              />
            </Column>
            <Column xs={4} sm={8} md={6} lg={6}>
              <ButtonOk
                isLarge={true}
                title="Finalizar"
                onClick={onTrigger}
                index={index}
                step={step}
              />
            </Column>
          </Row>
        </Margin>
      </Card>
      {modalIsOpen && (
        <ModalExpense
          title={isEdit ? editField : ""}
          amount={isEdit ? editAmount : ""}
          isEdit={isEdit}
          cancelOnClick={resetModal}
          onClick={resetModal}
        />
      )}
    </>
  );
};
